<template>
    <section class="payView">
		<van-nav-bar title="支付" class="top_bar" v-if="rechargeStatus == 0 || rechargeStatus == 1 || rechargeStatus == 2" />
		<van-nav-bar title="支付" left-arrow @click-left="skipSetting" class="top_bar" v-else />

        <section class="qrcode" v-if="cashierTypeCode=='SYB-APP' && rechargeStatus==1">
            <img :src="qrcodeBase64" alt="">
            <p>长按或截图保存，微信App扫码支付</p>
        </section>
        <div v-html="html" v-if="rechargeStatus == 0"></div>
        <section class="recharge_loading" v-else-if="rechargeStatus == 1">
            <img src="../../../assets/img/recharge_loading.png" />
            <p>正在查询支付结果，请稍后…</p>
        </section>
        <section class="recharge_fail" v-else-if="rechargeStatus == 2">
            <img src="../../../assets/img/recharge_fail.png" />
            <p>支付失败</p>
            <van-button round type="danger" class="danger-button" @click="skipService">联系客服</van-button>
        </section> 
        <section class="recharge_success" v-else-if="rechargeStatus == 3">
            <img src="../../../assets/img/recharge_success.png" />
            <p>支付成功</p>
            <van-button round type="danger" class="danger-button" @click="skipSetting">返回</van-button>
        </section>
    </section>
</template>

<script>
import settingServer from "api/setting";
import Nav from "components/Nav"
export default {
    name: "payView",
	components: {
		Nav,
	},
    data() {
        return {
            html: ``,
            rechargeStatus: 1,
			payId: '',
            payParams: {
                orderNo: "",
                cashierTypeId: "",
                returnUrl: "",
            },
            cashierTypeCode: '',
			isLoading: false,
            qrcodeBase64: '',
        };
    },
    
    created() {
		this.rechargeStatus = localStorage.getItem("rechargeStatus")

        this.payParams.orderNo = this.$route.params.orderNo;
        this.payParams.cashierTypeId = this.$route.params.cashierTypeId;
		this.payParams.returnUrl = `https://biz.baiqidai.com/#/setting/payview/payview/${this.payParams.orderNo}/${this.payParams.cashierTypeId}`;
		
        this.cashierTypeCode = this.$route.params.cashierTypeCode;
        
        if(this.rechargeStatus==0) { //提交收银台
            this.showPageView()
		}else {
			//轮询支付结果
			this.training = setInterval(this.getPayStatus, 400)
		}
	},

	beforeDestroy() {
		clearInterval(this.training)
	},

	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},

    methods: {
        showPageView() {
            // 提交收银台
            settingServer.submitCashier(this.payParams).then((res) => {
                //支付宝-wap
                if(this.cashierTypeCode=='AliPay-WAP') {
                    this.html = res.data.params.split('</form>')[0]
                    localStorage.setItem("rechargeStatus", 1)

                    this.$nextTick(() => {
                        document.forms[0].submit();
                    });
                }

                //收银宝-二维码
                if(this.cashierTypeCode=='SYB-APP') {
                    localStorage.setItem("rechargeStatus", 1)

                    this.qrcodeBase64 = res.data.params
                }
                
                setTimeout(() => {
                    this.rechargeStatus = 1
                    //轮询支付结果
			        this.training = setInterval(this.getPayStatus, 400)
                }, 1000)
            });
        },

        //查询支付结果
		getPayStatus() {
			settingServer.getRechargeOrderPageList({orderNo: this.payParams.orderNo, pageNum: 1, pageSize: 100}).then((res) => {
				if (!res.data) return

				if(res.data.list[0].paymentStatus == 1) {
					this.rechargeStatus = 1
					localStorage.setItem("rechargeStatus", 1)
				}else if(res.data.list[0].paymentStatus == 2 || res.data.list[0].paymentStatus == 4 || res.data.list[0].paymentStatus == 5) {
					this.rechargeStatus = 2
					localStorage.setItem("rechargeStatus", 2)
				}else if(res.data.list[0].paymentStatus == 3) {
					this.rechargeStatus = 3
					localStorage.setItem("rechargeStatus", 3)
				}

				if(res.data.list[0].paymentStatus != 1) {
					clearInterval(this.training)
				}
			})
		},

		skipService() {
			this.$router.push({name: 'service'})
		},
        
		skipSetting() {
			this.$router.push({name: 'setting'})
		},
    },
};
</script>

<style lang="scss">
.payView {
    .recharge_success,
    .recharge_fail {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 100%;
        img {
            width: 104px;
        }
        p {
            color: #2b2f3a;
            font-size: 20px;
            font-weight: bold;
            padding-top: 15px;
        }
        .van-button--danger {
            margin-top: 68px;
            width: 217px;
            height: 46px;
            font-size: 17px;
            font-weight: bold;
            .van-button__text {
                color: #fff;
                padding-top: 0;
            }
        }
    }
	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.block {
		width: 120px;
		height: 120px;
		background-color: #fff;
	}
	.van-loading {
		position: fixed;
		top: 30%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
    .recharge_loading {
        position: fixed;
        bottom: 0%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 100%;
        img {
            width: 120px;
        }
        p {
            color: #575e72;
            font-size: 16px;
            padding-top: 36px;
        }
    }

    .qrcode {
            margin-top: 48px;
			text-align: center;
			img {
				width: 240px;
			}
            p {
                font-size: 14px;
                line-height: 2;
            }
		}
}
</style>


// WEBPACK FOOTER //
// src/views/setting/payview/PayView.vue